export default __webpack_public_path__ + "static/MDSM-297a37dcf2e6595562e825c3f8c3aa8c.png";